/**
 * Defines the environment of the API domains.
 *
 * @public
 */
export var Environment;
(function (Environment) {
    Environment["PROD"] = "prod";
    Environment["SANDBOX"] = "sbx";
})(Environment || (Environment = {}));
//# sourceMappingURL=Environment.js.map